import { createSlice } from "@reduxjs/toolkit";

const guestsSlice = createSlice({
  name: "guests",
  initialState: {
    guests: {
        adults: 2,
        children: 0,
        infants: 0
    }
  },
  reducers: {
    setGuests: (state, action) => {
      state.guests = action.payload;
    },
    setGuestsAdults: (state, action) => {
      state.guests.adults = action.payload;
    },
    setGuestsChildren: (state, action) => {
      state.guests.children = action.payload;
    },
    setGuestsInfants: (state, action) => {
      state.guests.infants = action.payload;
    },
  },
});

export const { setGuests, setGuestsAdults, setGuestsChildren, setGuestsInfants } = guestsSlice.actions;
export const selectGuests = (state) => state.guests.guests;
export const selectGuestsCount = (state) : number => {
    const { adults, children, infants } = state.guests.guests;
    return adults + children + infants;
};

export default guestsSlice.reducer;